export default __webpack_public_path__ + "static/media/6.df89cc63.jpg";